angular.module("siter.io").directive "errSrc", ["$window", ($window) ->
  restrict: "A"
  link: (scope, element, attrs) ->
    attrs.$observe 'ngSrc', (value) ->
      if !value and attrs.errSrc
        attrs.$set 'src', attrs.errSrc
      return
    element.bind 'error', ->
      if attrs.src != attrs.errSrc
        attrs.$set 'src', attrs.errSrc
      return
    return
]



// WEBPACK FOOTER //
// ./src/app/common/directives/errsrc.coffee